import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/services', label: 'Services' },
  { to: '/events', label: 'Events' },
  { to: '/contact', label: 'Contact' }
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <div className="topbar">
        <div className="container">
          <div className="topbar-info">
            <span>127 Dean Road, Bolton BL3 5AG</span>
            <span className="topbar-hide-sm">Office: Mon · Wed · Fri, 10am – 2pm</span>
          </div>
          <div className="topbar-info">
            <a href="mailto:oromogadaacommunity@gmail.com">oromogadaacommunity@gmail.com</a>
            <a className="topbar-hide-sm" href="tel:+447493193493">+44 7493 193493</a>
          </div>
        </div>
      </div>

      <header className="header">
        <div className="container">
          <div className="nav-wrapper">
            <Link className="logo" to="/" onClick={closeMenu} aria-label="Oromo Gadaa-UK home">
              <img className="logo-img" src="/Images/logo.png" alt="Oromo Gadaa Community UK logo" width="56" height="56" />
              <span className="logo-text">
                <strong>Oromo Gadaa-UK</strong>
                <small>Community &amp; Heritage</small>
              </span>
            </Link>

            <button
              className={`hamburger ${isMenuOpen ? 'active' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
              aria-controls="primary-navigation"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <nav id="primary-navigation" className={`navigation ${isMenuOpen ? 'active' : ''}`}>
              <ul className="nav-menu">
                {navItems.map(item => (
                  <li key={item.to}>
                    <NavLink to={item.to} end onClick={closeMenu}>
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
              <Link className="btn btn-primary nav-cta" to="/contact" onClick={closeMenu}>Get Involved</Link>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
